enum ModeloPreDefinido {
    Personalizado = 0,
    PDFFracionamento = 1,
    Acabados = 2,
}

export default ModeloPreDefinido;
